import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { AcademyService } from "../../../../Report/report-services/academy.service";
import { GradeLevelService } from "../../../../Report/report-services/grade-level.service";
import { GroupService } from "../../../../Report/report-services/group.service";
import { HomeroomService } from "../../../../Report/report-services/homeroom.service";
import { SchoolselectorService } from "../../../../schoolselector/schoolselectorservice.service";
import { DataService_Student_DigitalID } from "../../shared/data.service";

@Component({
	selector: "app-export-digital-id",
	templateUrl: "./export-digital-id.component.html",
	styleUrls: ["./export-digital-id.component.css"],
})
export class ExportDigitalIDComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private selectService: SchoolselectorService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private groupService: GroupService,
		private idService: DataService_Student_DigitalID
	) {}

	ngOnInit(): void {
		this.loadFormatOptions();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	///////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////

	subscription: any;

	LoadingFormatOptions: boolean = true;
	SelectedFormatOption: any;
	lstFormatOptions: any = [];

	School: any;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "All Schools";

	LoadingGradeLevel: boolean = true;
	SelectedGradeLevel: any;
	lstGradeLevel: any = [];

	LoadingAcademy: boolean = true;
	SelectedAcademy: any;
	lstAcademy: any = [];

	LoadingHomeroom: boolean = true;
	SelectedHomeroom: any;
	lstHomeroom: any = [];

	LoadingGroup: boolean = true;
	SelectedGroup: any;
	lstGroup: any = [];

	ActiveOptionID: any = 1;
	lstActiveOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	AlreadyPrintedID: any = -1;
	lstAlreadyPrinted: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Digital ID Printed",
		},
		{
			ID: 0,
			Desc: "Digital ID Not Printed",
		},
	];

	IsProcessing: boolean = false;

	errorMessage: string = "";

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////////

	loadFormatOptions() {
		this.LoadingFormatOptions = true;

		var result = this.idService.ExportFormatOptionSelectList();
		result.subscribe(
			(response) => {
				this.lstFormatOptions = response;

				this.SelectedFormatOption = this.lstFormatOptions[0];
				this.LoadingFormatOptions = false;
			},
			(error) => {
				this.LoadingFormatOptions = false;
			}
		);
	}

	loadGradeLevel() {
		this.LoadingGradeLevel = true;

		var result = this.gradelevelService.loadGradeLevelList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				if (this.lstGradeLevel.length == 0) {
					this.lstGradeLevel.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "All Grade Levels",
					});
				}

				this.SelectedGradeLevel = this.lstGradeLevel[0];
				this.LoadingGradeLevel = false;
			},
			(error) => {
				this.LoadingGradeLevel = false;
			}
		);
	}

	loadAcademy() {
		this.LoadingAcademy = true;

		var result = this.academyService.loadAcademyList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				if (this.lstAcademy.length == 0) {
					this.lstAcademy.unshift({
						AcademyId: -1,
						AcademyDesc: "All Academies",
					});
				}

				this.SelectedAcademy = this.lstAcademy[0];
				this.LoadingAcademy = false;
			},
			(error) => {
				this.LoadingAcademy = false;
			}
		);
	}

	loadHomeroom() {
		this.LoadingHomeroom = true;

		var result = this.homeroomService.loadHomeroomList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				if (this.lstHomeroom.length == 0) {
					this.lstHomeroom.unshift({
						HomeroomId: -1,
						HomeRoom: "All Homerooms",
					});
				}

				this.SelectedHomeroom = this.lstHomeroom[0];
				this.LoadingHomeroom = false;
			},
			(error) => {
				this.LoadingHomeroom = false;
			}
		);
	}

	loadGroup() {
		this.LoadingGroup = true;

		var result = this.groupService.loadGroupList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				if (this.lstGroup.length == 0) {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupName: "All Groups",
					});
				}

				this.SelectedGroup = this.lstGroup[0];
				this.LoadingGroup = false;
			},
			(error) => {
				this.LoadingGroup = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////
	onExport() {
		this.IsProcessing = true;

		//
		// Get data from WS
		//
		var result = this.idService.ExportSelectList(
			this.School.SchoolID,
			this.SelectedGradeLevel.GradeLevelID,
			this.SelectedAcademy.AcademyId,
			this.SelectedHomeroom.HomeroomId,
			this.SelectedGroup.GroupID,
			this.ActiveOptionID,
			this.AlreadyPrintedID,
			this.SelectedFormatOption.ID
		);
		result.subscribe(
			(response) => {
				this.IsProcessing = false;

				var Data: any = response[0];

				if (Data != undefined) {
					var a = document.createElement("a"); //Create <a>

					var FileName = "DigitalID_Export_";

					if (this.School.SchoolID > 0) {
						FileName += this.School.SchoolNumber;
					} else {
						FileName += this.School.SchoolName;
					}

					//Text tab
					if (this.SelectedFormatOption.ID == 1) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//Text comma
					else if (this.SelectedFormatOption.ID == 2) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//CSV
					else if (this.SelectedFormatOption.ID == 3) {
						a.href = "data:text/csv;base64," + response[0];
						a.download = FileName + ".csv";
						a.click(); //Downloaded file
					}
				} else {
					this.errorMessage = "Error Exporting Data";
				}
			},
			(error) => {
				this.IsProcessing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////
	onSchoolChange(school) {
		this.School = school;

		//Load Data
		this.loadGradeLevel();
		this.loadAcademy();
		this.loadHomeroom();
		this.loadGroup();
	}
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////////
	IsLoading() {
		return (
			this.LoadingFormatOptions == true ||
			this.LoadingGradeLevel == true ||
			this.LoadingAcademy == true ||
			this.LoadingHomeroom == true ||
			this.LoadingGroup == true ||
			this.IsProcessing == true
		);
	}
	///////////////////////////////////////////////////////////////////////////
}
